import { programLabels } from '@/config';
import { getManufacturerByProgram } from '@/libs/util';

const Gamunex = ({ name, themeColor }: { name: string; themeColor: string }) => {
  return (
    <>
      <div className="mx-auto py-10">
        <div className="text-xl md:text-3xl font-bold text-[#000000]">
          <span style={{ color: themeColor }}>
            {programLabels[name as keyof typeof programLabels].name}
          </span>
          &nbsp; SUPPORT FOR PATIENTS
        </div>

        <div className="mt-10 text-2xl font-bold">COPAY ASSISTANCE</div>

        <p className="my-2">
          Eligible patients can receive up to $10,000 over a calendar year to cover the
          deductible,copay,and/or coinsurance for GAMUNEX-C.
        </p>

        <ul className="my-2 list-disc ml-10">
          <li>
            Please ask your provider to bill Medmonk for your copay assistance at the time of
            dispensing. This streamlined approach facilitates the process, ensuring prompt access to
            the copay assistance you need.
          </li>
          <li>
            GAMUNEX-C copay assistance can typically be used regardless of whether your healthcare
            provider is billing through your major medical plan or your pharmacy benefits.
          </li>
        </ul>

        <div className="mt-10 font-bold">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE</div>

        <ul className="my-2 list-disc ml-10">
          <li>Commercially insured patients only</li>
          <li>Patients must express a financial need.</li>
          <li>Assistance available for the treatment of CIDP or PIDD.</li>
          <li>
            Patients' health plan permits members to participate in copay assistance programs.
          </li>
        </ul>

        <div className="my-2 font-bold">RESTRICTIONS</div>

        <ul className="my-2 list-disc ml-10">
          <li>
            Patients are ineligible for copay assistance if they participate in Medicare, Medicaid,
            Medigap, Veterans Affairs, Department of Defense, Tricare, or any other federal or
            state-funded programs
          </li>
        </ul>

        <div className="mt-10">
          This program is subject to change or discontinuation by&nbsp;
          <b>{getManufacturerByProgram(name)}</b>
          &nbsp;at any time, for any reason, and with or without prior notice. This portal is
          administered by&nbsp;
          <a target="_blank" href="https://medmonk.com/" className="text-blue-500 hover:underline">
            Medmonk
          </a>
          &nbsp;for the {programLabels[name as keyof typeof programLabels]?.label} Program.
        </div>
      </div>
    </>
  );
};

export default Gamunex;
